export default __webpack_public_path__ + "static/media/firebase.82a35fc0.svg";